import { displayToast } from '../../../../helpers/notification';
import { FaqTypes as Type } from '../../../types/faq';

export function DeleteFaqRequest(id: any) {
  return {
    type: Type.DELETE_FAQ_REQUEST,
    id,
  };
}

export function DeleteFaqRequestSuccess(data: any) {
  return {
    type: Type.DELETE_FAQ_REQUEST_SUCCESS,
    payload: data,
  };
}

export function DeleteFaqRequestFailure(error: any) {
  try {
    if (
      error.response &&
      error.response.data &&
      error.response.data.message &&
      error.response.data.message.length > 0
    ) {
      if (Array.isArray(error.response.data.message))
        displayToast('ERROR', error.response.data.message[0]);
      else displayToast('ERROR', error.response.data.message);
    } else {
      displayToast('ERROR', error.message);
    }
  } catch (e) {
    displayToast('ERROR', error.message);
  }
  return {
    type: Type.DELETE_FAQ_REQUEST_FAILURE,
    error: error,
  };
}

export function ResetDeleteFaqState() {
  return {
    type: Type.RESET_DELETE_FAQ_STATE,
  };
}
